import React from 'react';

import { nationalRegistryTypes } from './actions'


const initialState = {
    isFetching: false,
    data: [],
    history: [],
    namespaced: {},
    stringResult: [],
}

export function nationalRegistry(state = initialState, action) {


    switch(action.type) {

        case nationalRegistryTypes.REQUEST:
            state = {...state}
            state.isFetching = false;
            return state

        case nationalRegistryTypes.RECEIVE:

            state = {...state}

            let _data = []
            let _history = []

            if (action.data.length > 0) {
                let person = action.data[0].NationalRegistry
                let family = []
                if (person.FamilyList) {
                    family = person.FamilyList.Family
                }
                _data = [person].concat(family)
                _history = state.history.concat(_data)
            } else {
                _history = state.history.concat(state.data)
                _data = []
            }

            state.data = _data
            state.history = _history
            // state.data = action.data.map(item => item.NationalRegistry)

            return state

        case nationalRegistryTypes.RECEIVE_STR:
            state = {...state}
            state.stringResult = action.data[0].NationalRegistry.NationalRegistryLine
            return state

        default:
            return state
    }
}

const namespacedInitialState = {
    isFetching: false,
    data: {}
}


export function nationalRegistryNamespaced(state = namespacedInitialState, action) {

    switch(action.type) {

        case nationalRegistryTypes.REQUEST_NAMESPACED:
            state = {...state}
            if (state[action.namespace]) {
                state[action.namespace].isFetching = true
            } else {
                state[action.namespace] = {
                    isFetching: true,
                    data: []
                }
            }
            return state

        
        case nationalRegistryTypes.REQUEST_NAMESPACED_STRING:
            state = {...state}
            if (state[action.namespace]) {
                state[action.namespace].isFetching = true
                state[action.namespace].data = []
            } else {
                state[action.namespace] = {
                    isFetching: true,
                    data: []
                }
            }
            return state

        case nationalRegistryTypes.RECEIVE_NAMESPACED:
            state = {...state}
            state[action.namespace].isFetching = false

            let _namespaceddata = []

            if (action.data.length > 0) {
                let person = action.data[0].NationalRegistry
                let family = []
                if (person.FamilyList) {
                    family = person.FamilyList.Family
                }
                _namespaceddata = [person].concat(family)
            } else {
                _namespaceddata = []
            }

            state[action.namespace].data = _namespaceddata
            // state.data = action.data.map(item => item.NationalRegistry)            
            return state
            
        case nationalRegistryTypes.RECEIVE_NAMESPACED_STRING:
            const key = action.namespace;
            const data = action.data?.[0]?.NationalRegistry?.NationalRegistryLine ?? [];
            return {
                ...state,
                [key]: {
                    data: data
                }
            }

        default:
            return state
    }
}